;(async () => {
  if (!customElements.get('cart-message')) {
    const { default: Cookies } = await import('js-cookie')

    class CartMessage extends HTMLElement {
      constructor() {
        super()

        this.cookieIdentifier = 'cart-message-hidden'
        this.closeButton = this.querySelector('[data-cart-message-close]')
        this.closeButton.addEventListener('click', this.handleClose.bind(this))

        if (typeof Cookies.get(this.cookieIdentifier) !== 'undefined') {
          this.handleClose()
        }
      }

      handleClose() {
        const footerWrapper = this.closest('.cart-drawer__footer')

        if (footerWrapper) {
          footerWrapper.style.boxShadow = null
        }
        this.classList.add('cart-message--hidden')

        Cookies.set(this.cookieIdentifier, true, {
          expires: 14,
        })
      }
    }

    window.CartMessage = CartMessage
    customElements.define('cart-message', CartMessage)
  }
})()
